"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const d3 = __importStar(require("d3"));
const lodash_1 = __importDefault(require("lodash"));
const format_1 = require("./format");
const common_module_scss_1 = __importDefault(require("../styles/common.module.scss"));
const usStates_1 = require("../components/Cartogram/usStates");
const util_1 = require("../components/Cartogram/util");
const colours_module_scss_1 = __importDefault(require("../styles/colours.module.scss"));
const chart_helpers_1 = require("./chart.helpers");
const usafactsBase64_1 = __importDefault(require("./usafactsBase64"));
function drawTitle(canvas, x, y, parts) {
  let fontSize = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : parseFloat(common_module_scss_1.default.chartTitleFontSize);
  const context = canvas.getContext('2d');
  context.textBaseline = 'middle';
  context.textAlign = 'left';
  context.font = `600 ${fontSize}px ${common_module_scss_1.default.mainFontFamily}`;
  let drawnWidth = 0;
  parts.forEach(_ref => {
    let {
      text,
      color
    } = _ref;
    context.fillStyle = color;
    context.fillText(text, x + drawnWidth, y);
    drawnWidth += context.measureText(`${text} `).width;
  });
}
exports.default = {
  drawTitles(canvas, _ref2, key1, color1, key2, color2) {
    let {
      title,
      subtitle,
      margins,
      titleFontSize,
      subtitleFontSize
    } = _ref2;
    let xOffset = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
    let yOffset = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
    const context = canvas.getContext('2d');
    const titleLineHeight = parseFloat(common_module_scss_1.default.chartTitleLineHeight) * titleFontSize;
    const subtitleLineHeight = parseFloat(common_module_scss_1.default.chartSubtitleLineHeight) * subtitleFontSize;
    const horizontalMargin = margins.left + xOffset;
    let y = yOffset;
    const titleParts = [{
      text: title,
      color: common_module_scss_1.default.chartTitleColor
    }];
    if (key1 !== undefined) {
      titleParts.push({
        text: key1,
        color: color1
      });
    }
    if (key2 !== undefined) {
      titleParts.push({
        text: 'vs',
        color: common_module_scss_1.default.chartTitleColor
      });
      titleParts.push({
        text: key2,
        color: color2
      });
    }
    context.font = `bold ${common_module_scss_1.default.chartTitleFontSize}px ${common_module_scss_1.default.mainFontFamily}`;
    drawTitle(canvas, horizontalMargin, y + titleLineHeight / 2, titleParts, titleFontSize);
    y += titleLineHeight;
    context.font = `${subtitleFontSize}px ${common_module_scss_1.default.chartSubitleFontFamily}`;
    context.fillStyle = common_module_scss_1.default.chartSubitleColor;
    if (subtitle !== undefined) {
      context.fillText(subtitle, horizontalMargin, y + subtitleLineHeight / 2);
    }
  },
  drawAxis(canvas, data, _ref3, scale) {
    let {
      hideAxisLabels,
      hideGridlines,
      fontSize
    } = _ref3;
    let position = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'top';
    let ticksCount = arguments.length > 5 ? arguments[5] : undefined;
    let lineLength = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
    let format = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : value => value;
    let xOffset = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;
    let yOffset = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 0;
    const context = canvas.getContext('2d');
    const ticks = scale.ticks(ticksCount);
    const d3AxisOffset = 10;
    let textAlign;
    let drawLabel;
    let drawLine = () => undefined;
    if (position === 'left') {
      textAlign = 'left';
      drawLabel = tick => {
        context.fillText(format(tick), xOffset - d3AxisOffset, yOffset + scale(tick));
      };
    } else if (position === 'right') {
      textAlign = 'right';
      drawLabel = tick => {
        context.fillText(format(tick), xOffset + scale(tick), yOffset - d3AxisOffset);
      };
    } else if (position === 'top') {
      textAlign = 'center';
      drawLabel = tick => {
        context.fillText(format(tick), xOffset + scale(tick), yOffset - d3AxisOffset);
      };
      drawLine = tick => {
        context.moveTo(xOffset + scale(tick), yOffset);
        context.lineTo(xOffset + scale(tick), yOffset + lineLength);
      };
    } else if (position === 'bottom') {
      textAlign = 'center';
      drawLabel = tick => {
        context.fillText(format(tick), xOffset + scale(tick), yOffset + d3AxisOffset);
      };
    } else {
      console.warn(`Invalid position parameter - ${position}. Must be 'left', 'right', 'top' or 'bottom'`);
      return;
    }
    context.font = `${fontSize}px ${common_module_scss_1.default.mainFontFamily}`;
    context.fillStyle = common_module_scss_1.default.chartAxisFontColor;
    context.lineWidth = 1;
    context.strokeStyle = common_module_scss_1.default.chartAxisTickColor;
    // let textY;
    context.textBaseline = 'middle';
    context.textAlign = textAlign;
    context.beginPath();
    ticks.forEach(tick => {
      if (!hideAxisLabels) {
        drawLabel(tick);
      }
      if (!hideGridlines) {
        drawLine(tick);
      }
    });
    context.stroke();
  },
  drawMapLegend(canvas, data, year, _ref4, scale, legendLength) {
    let {
      fontSize
    } = _ref4;
    let format = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : value => value;
    let xOffset = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
    let yOffset = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;
    const context = canvas.getContext('2d');
    const values = data.map(d => {
      const entry = d.metric.data.find(k => {
        if (d.metric.xType && d.metric.xType.toLowerCase() === 'items') {
          return k.key === year;
        }
        return k.key.getTime() === (0, chart_helpers_1.dateParser)(year, d.metric.xType).getTime();
      });
      return entry !== undefined ? entry.value : null;
    });
    const min = lodash_1.default.min(values);
    const max = lodash_1.default.max(values);
    const ticks = lodash_1.default.reverse(lodash_1.default.flattenDeep([min, scale.domain(), max]));
    const colors = lodash_1.default.reverse(scale.range());
    context.lineWidth = 5;
    context.textBaseline = 'middle';
    context.textAlign = 'left';
    context.font = `${fontSize}px ${common_module_scss_1.default.mainFontFamily}`;
    context.fillStyle = '#646464';
    colors.forEach((color, i) => {
      context.strokeStyle = color;
      context.beginPath();
      context.moveTo(xOffset, yOffset + i * legendLength / colors.length);
      context.lineTo(xOffset, yOffset + (i + 1) * legendLength / colors.length);
      context.stroke();
      context.fillText(format(ticks[i]), xOffset + 5, yOffset + i * legendLength / colors.length);
    });
    context.fillText(format(ticks[ticks.length - 1]), xOffset + 5, yOffset + legendLength);
  },
  drawLineChartAxis(canvas, data, _ref5, xScale, yScale) {
    let {
      hideAxisLabels,
      hideGridlines,
      fontSize
    } = _ref5;
    let format = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : value => value;
    let numYTicks = arguments.length > 6 ? arguments[6] : undefined;
    let xOffset = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
    let yOffset = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;
    const context = canvas.getContext('2d');
    const [xStart, xEnd] = xScale.range();
    const leftLabelMargin = xStart;
    const width = xEnd - xStart;
    let xTickCount;
    if (width > 760) {
      xTickCount = 8;
    } else if (width > 400) {
      xTickCount = 4;
    } else {
      xTickCount = 3;
    }
    const xTicks = xScale.ticks(xTickCount);
    const yTicks = yScale.ticks(numYTicks);
    const xFormat = xScale.tickFormat();
    const yFormat = format;
    const d3AxisOffset = 10;
    context.font = `${fontSize}px ${common_module_scss_1.default.mainFontFamily}`;
    context.fillStyle = common_module_scss_1.default.chartAxisFontColor;
    context.lineWidth = 1;
    context.strokeStyle = common_module_scss_1.default.chartAxisTickColor;
    let textX = leftLabelMargin - d3AxisOffset + xOffset;
    let textY;
    context.textBaseline = 'middle';
    context.textAlign = 'right';
    context.beginPath();
    yTicks.forEach(tick => {
      textY = yScale(tick) + yOffset;
      if (!hideAxisLabels) {
        context.fillText(yFormat(tick), textX, textY);
      }
      if (!hideGridlines) {
        context.moveTo(xScale.range()[0], textY);
        context.lineTo(xScale.range()[1], textY);
      }
    });
    context.stroke();
    context.textBaseline = 'top';
    context.textAlign = 'center';
    textY = yScale.range()[0] + d3AxisOffset + yOffset;
    xTicks.forEach(tick => {
      textX = xScale(tick) + xOffset;
      if (!hideAxisLabels) {
        context.fillText(xFormat(tick), textX, textY);
      }
    });
  },
  drawDots(canvas, data, params, key1, key2, xScale, yScale) {
    let xOffset = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
    let yOffset = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;
    let color1 = arguments.length > 9 ? arguments[9] : undefined;
    let color2 = arguments.length > 10 ? arguments[10] : undefined;
    let lineColor = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : colours_module_scss_1.default.chartcolourgrey;
    const context = canvas.getContext('2d');
    const keyValueAccessor = (key, d) => {
      const entry = d.metric.data.find(k => {
        if (d.metric.xType && d.metric.xType.toLowerCase() === 'items') {
          return k.key === key;
        }
        return k.key.getTime() === (0, chart_helpers_1.dateParser)(key, d.metric.xType).getTime();
      });
      return entry !== undefined ? entry.value : null;
    };
    const someSelectedStates = lodash_1.default.some(data, d => d.selectedState);
    const fillDots = (key, radius, stroke) => {
      data.forEach(d => {
        const value = keyValueAccessor(key, d);
        if (value === null) {
          return;
        }
        if (someSelectedStates && !d.selectedState) {
          context.globalAlpha = 0.4;
        } else {
          context.globalAlpha = 1;
        }
        const x = xScale(value) + xOffset;
        const y = yScale((0, chart_helpers_1.uniqueMetricMap)(d)) + yOffset;
        context.beginPath();
        context.arc(x, y, radius, 0, 2 * Math.PI);
        if (stroke) {
          context.stroke();
        }
        context.fill();
      });
      context.globalAlpha = 1;
    };
    const bigCircleSize = params.fontSize / 14 * 7;
    const smallCircleSize = params.fontSize / 14 * 5;
    context.strokeStyle = lineColor;
    data.forEach(d => {
      const v1 = keyValueAccessor(key1, d);
      const v2 = keyValueAccessor(key2, d);
      if (v1 === null || v2 === null) {
        return;
      }
      if (someSelectedStates && !d.selectedState) {
        context.globalAlpha = 0.4;
      } else {
        context.globalAlpha = 1;
      }
      let direction = 1;
      if (v2 < v1) {
        direction = -1;
      }
      const x1 = xScale(v1) + xOffset + smallCircleSize * direction;
      const x2 = xScale(v2) + xOffset - bigCircleSize * direction;
      if (direction === 1 && x2 - x1 < 0 || direction === -1 && x2 - x1 > 0) {
        return;
      }
      const y = yScale((0, chart_helpers_1.uniqueMetricMap)(d)) + yOffset;
      context.beginPath();
      context.moveTo(x1, y);
      context.lineTo(x2, y);
      context.stroke();
    });
    context.globalAlpha = 1;
    context.fillStyle = color2;
    fillDots(key2, bigCircleSize);
    context.fillStyle = color1;
    context.strokeStyle = '#FFF';
    fillDots(key1, smallCircleSize, true);
  },
  drawBars(canvas, data, _ref6, key, xScale, yScale) {
    let {
      margins,
      fontSize
    } = _ref6;
    let xOffset = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
    let yOffset = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
    let colorAccessor = arguments.length > 8 ? arguments[8] : undefined;
    let format = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : value => value;
    const context = canvas.getContext('2d');
    const keyData = data.map(d => {
      const entry = d.metric.data.find(k => {
        if (d.metric.xType && d.metric.xType.toLowerCase() === 'items') {
          return k.key === key;
        }
        return k.key.getTime() === (0, chart_helpers_1.dateParser)(key, d.metric.xType).getTime();
      });
      return entry !== undefined ? entry.value : null;
    });
    context.textBaseline = 'middle';
    context.textAlign = 'left';
    context.font = `${fontSize}px ${common_module_scss_1.default.mainFontFamily}`;
    const someSelectedStates = lodash_1.default.some(data, d => d.selectedState);
    data.forEach((d, i) => {
      if (keyData[i] === null) {
        return;
      }
      if (someSelectedStates && !d.selectedState) {
        context.globalAlpha = 0.4;
      } else {
        context.globalAlpha = 1;
      }
      const width = xScale(keyData[i]) - xScale(0);
      const height = yScale.bandwidth();
      const x = xScale(0);
      const y = yScale((0, chart_helpers_1.uniqueMetricMap)(d)) + yOffset;
      context.fillStyle = colorAccessor(d) || colours_module_scss_1.default.chartcolourdefault0;
      context.fillRect(x, y - height / 2, width, height);
      context.fillStyle = common_module_scss_1.default.chartTitleColor;
      const textX = Math.max(xScale(0), xScale(keyData[i])) + xOffset;
      context.fillText(format(keyData[i]), textX + margins.valueLabelPadding, y);
    });
    context.globalAlpha = 1;
  },
  drawLeftLabels(canvas, data, params, yScale, width) {
    let xOffset = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    let yOffset = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
    const context = canvas.getContext('2d');
    let labelMode;
    const allSameState = lodash_1.default.every(data, _ref7 => {
      let {
        metric
      } = _ref7;
      return metric.geo_id === data[0].metric.geo_id;
    });
    if (allSameState) {
      labelMode = 'metrics';
    }
    const allSameMetric = lodash_1.default.every(data, _ref8 => {
      let {
        metric
      } = _ref8;
      return metric.id === data[0].metric.id;
    });
    if (allSameMetric) {
      labelMode = 'states';
    }
    const text = lodash_1.default.map(data, d => (0, chart_helpers_1.getLabelText)(d, labelMode));
    const {
      fontSize
    } = params;
    context.textBaseline = 'middle';
    context.textAlign = 'left';
    context.font = `${fontSize}px ${common_module_scss_1.default.mainFontFamily}`;
    context.fillStyle = common_module_scss_1.default.chartTitleColor;
    const longestLabelWidth = lodash_1.default.max(text.map(t => context.measureText(t).width));
    const someSelectedStates = lodash_1.default.some(data, d => d.selectedState);
    data.forEach((d, i) => {
      if (someSelectedStates && !d.selectedState) {
        context.globalAlpha = 0.4;
      } else {
        context.globalAlpha = 1;
      }
      context.fillText(text[i], xOffset, yScale((0, chart_helpers_1.uniqueMetricMap)(d)) + yOffset);
    });
    context.globalAlpha = 1;
    return {
      fontSize,
      longestLabelWidth
    };
  },
  drawLineLabels(chart, canvas, labels, params, xScale, padding) {
    let fontSize = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 20;
    let xOffset = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
    let yOffset = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;
    const context = canvas.getContext('2d');
    context.textBaseline = 'middle';
    context.textAlign = 'left';
    context.font = `bold ${fontSize}px ${common_module_scss_1.default.mainFontFamily}`;
    const x = xScale.range()[1] + padding;
    labels.forEach((label, i) => {
      context.fillStyle = chart.colourFunction(label, i, params);
      label.text.forEach((text, j) => {
        context.fillText(text, x + xOffset, label.y + yOffset + j * fontSize * 0.9);
      });
    });
  },
  drawLines(chart, canvas, data, params, xScale, yScale) {
    let showArea = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    let xOffset = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
    let yOffset = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;
    const context = canvas.getContext('2d');
    const line = d3.line().x(d => xScale(d.key) + xOffset).y(d => yScale(d.value) + yOffset).context(context);
    data.forEach((d, i) => {
      context.lineCap = 'round';
      if (showArea) {
        context.lineCap = 'butt';
        const gradient = context.createLinearGradient(0, yScale.range()[1] + yOffset, 0, yScale.range()[0] + yOffset);
        gradient.addColorStop(0, chart.colourFunction(d, i, params));
        gradient.addColorStop(1, 'rgb(247, 250, 253)');
        const lastYear = d.metric.data[d.metric.data.length - 1].key;
        const firstYear = d.metric.data[0].key;
        context.beginPath();
        line(d.metric.data.filter(v => v.value !== null));
        context.lineTo(xScale(lastYear) + xOffset, yScale.range()[0] + yOffset);
        context.lineTo(xScale(firstYear) + xOffset, yScale.range()[0] + yOffset);
        context.fillStyle = gradient;
        context.fill();
      }
      context.lineWidth = d.lineSize || params.lineSize || 4;
      context.strokeStyle = chart.colourFunction(d, i, params);
      context.beginPath();
      line(d.metric.data.filter(v => v.value !== null));
      context.stroke();
    });
  },
  // eslint-disable-next-line default-param-last
  drawMap(canvas, data, features, width) {
    let x = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    let y = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    let colorAccessor = arguments.length > 6 ? arguments[6] : undefined;
    const mapXAdjustment = 90;
    const context = canvas.getContext('2d');
    const [albersX, albersY] = d3.geoAlbersUsa().translate();
    const scale = width / ((albersX - mapXAdjustment) * 2);
    const defaultScale = d3.geoAlbersUsa().scale();
    const projection = d3.geoAlbersUsa().scale(scale * defaultScale).translate([scale * (albersX - mapXAdjustment) + x, scale * albersY + y]);
    const path = d3.geoPath(projection).context(context);
    context.lineWidth = scale * 2;
    const selectedStates = lodash_1.default.map(data[0].states, 'fips');
    (0, lodash_1.default)(features).sortBy(_ref9 => {
      let {
        id
      } = _ref9;
      return lodash_1.default.includes(selectedStates, id);
    }).forEach(feature => {
      context.fillStyle = colorAccessor(data, feature.properties.name);
      context.beginPath();
      path(feature);
      context.fill();
      context.strokeStyle = lodash_1.default.includes(selectedStates, feature.id) ? '#616161' : 'white';
      context.stroke();
    });
  },
  // eslint-disable-next-line default-param-last
  drawCartogram(canvas, data, width) {
    let xOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    let yOffset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    let colorAccessor = arguments.length > 5 ? arguments[5] : undefined;
    const context = canvas.getContext('2d');
    const defaultWidth = 960;
    const scale = width / defaultWidth;
    const stroke = scale * 4;
    context.strokeStyle = 'white';
    context.lineWidth = stroke;
    (0, usStates_1.stateIdx)(usStates_1.statesGrid).forEach(_ref10 => {
      let {
        i,
        j,
        properties
      } = _ref10;
      context.fillStyle = colorAccessor(data, properties.name);
      context.beginPath();
      (0, util_1.hexPolygon)({
        i,
        j,
        properties
      }, width, stroke).forEach((point, index) => {
        const x = point[0] + xOffset;
        const y = point[1] + yOffset;
        if (index === 0) {
          context.moveTo(x, y);
        } else {
          context.lineTo(x, y);
        }
      });
      context.closePath();
      context.stroke();
      context.fill();
      const {
        x,
        y
      } = (0, util_1.hexDimensions)(i, j, width, stroke);
      context.textBaseline = 'middle';
      context.textAlign = 'center';
      context.fillStyle = 'white';
      context.font = `bold 16px ${common_module_scss_1.default.mainFontFamily}`;
      context.fillText(properties.abbr, x + xOffset, y + yOffset);
    });
  },
  drawSparklineDecorators(canvas, data, _ref11, xScale, yScale, color) {
    let {
      hideAxisLabels,
      hideGridlines,
      fontSize
    } = _ref11;
    let axisFormat = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : value => value;
    let radius = arguments.length > 7 ? arguments[7] : undefined;
    let xOffset = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;
    let yOffset = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 0;
    const context = canvas.getContext('2d');
    const sortedData = (0, lodash_1.default)(data).flatMap(lodash_1.default.property(['metric', 'data'])).sortBy('key').value();
    const xType = (0, lodash_1.default)(data).flatMap(lodash_1.default.property(['metric', 'xType'])).first();
    const yType = (0, lodash_1.default)(data).flatMap(lodash_1.default.property(['metric', 'yType'])).first() || '';
    const scaleTicks = yScale.ticks();
    const [xStart] = xScale.range();
    const ticks = [scaleTicks[0], scaleTicks[scaleTicks.length - 1]];
    const d3AxisOffset = 10;
    const drawLine = () => {
      context.moveTo(xOffset + xStart, yOffset + yScale.range()[0]);
      context.lineTo(xOffset + xStart, yOffset + yScale.range()[1]);
    };
    const drawLabel = tick => {
      context.fillText(axisFormat(tick), xOffset + xStart - d3AxisOffset / 2, yOffset + yScale(tick));
    };
    context.font = `${fontSize}px ${common_module_scss_1.default.mainFontFamily}`;
    context.fillStyle = common_module_scss_1.default.chartAxisFontColor;
    context.lineWidth = 1;
    context.strokeStyle = common_module_scss_1.default.chartAxisTickColor;
    context.textBaseline = 'middle';
    context.textAlign = 'right';
    context.beginPath();
    ticks.forEach(tick => {
      if (!hideAxisLabels) {
        drawLabel(tick);
      }
      if (!hideGridlines) {
        drawLine(tick);
      }
    });
    context.stroke();
    context.textBaseline = 'alphabetic';
    const values = [lodash_1.default.first(sortedData), lodash_1.default.last(sortedData)];
    values.forEach((value, i) => {
      if (i === 0) {
        context.textAlign = 'left';
      } else {
        context.textAlign = 'right';
      }
      context.fillText((0, chart_helpers_1.dateFormat)(value.key, xType), xOffset + xScale(value.key) + (i === 0 ? -3 : 3), yOffset + yScale.range()[0] + 1.5 * d3AxisOffset);
    });
    context.fillStyle = color;
    values.forEach((value, i) => {
      if (i === 0) {
        context.textAlign = 'left';
      } else {
        context.textAlign = 'right';
      }
      context.fillText((0, format_1.annotationFormat)(value.value, {
        values,
        type: yType
      }), xOffset + xScale(value.key) + (i === 0 ? -3 : 3), yOffset + yScale.range()[0] + 1.5 * d3AxisOffset + fontSize);
    });
    if (ticks[0] < 0 && ticks[1] > 0) {
      const y = yOffset + yScale(0);
      context.beginPath();
      context.moveTo(xOffset + xScale.range()[0], y);
      context.lineTo(xOffset + xScale.range()[1], y);
      context.stroke();
      if (Math.abs(yScale(0) - yScale(ticks[0])) > fontSize && Math.abs(yScale(0) - yScale(ticks[1])) > fontSize) {
        context.fillStyle = common_module_scss_1.default.chartAxisFontColor;
        context.textBaseline = 'middle';
        context.beginPath();
        drawLabel(0);
        context.fill();
      }
    }
    context.fillStyle = color;
    context.beginPath();
    values.forEach(value => {
      const x = xOffset + xScale(value.key);
      const y = yOffset + yScale(value.value);
      context.ellipse(x, y, radius, radius, 0, 0, 2 * Math.PI);
    });
    context.fill();
  },
  drawFooter(canvas, width, yOffset) {
    const context = canvas.getContext('2d');
    const footerText = 'Explore the data and source at usafacts.org © 2019 USAFacts.org. All rights reserved.';
    context.textBaseline = 'alphabetic';
    context.textAlign = 'center';
    context.font = `${12}px ${common_module_scss_1.default.mainFontFamily}`;
    context.fillStyle = '#555';
    context.fillText(footerText, width / 2, yOffset);
  },
  async drawLogo(canvas, width, _ref12) {
    let {
      margins
    } = _ref12;
    let topMargin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 40;
    return new Promise((resolve, reject) => {
      const logo = usafactsBase64_1.default;
      const logoImage = new window.Image();
      logoImage.onload = () => {
        const context = canvas.getContext('2d');
        const logoHeight = 20;
        context.drawImage(logoImage, margins.left, topMargin, 162, logoHeight);
        context.textBaseline = 'alphabetic';
        context.textAlign = 'right';
        context.font = `${20}px ${common_module_scss_1.default.mainFontFamily}`;
        context.fillStyle = '#555';
        const tagline = 'OUR NATION, IN NUMBERS';
        const y = topMargin + 20;
        let x = width - margins.right;
        for (let i = tagline.length - 1; i >= 0; i -= 1) {
          context.fillText(tagline[i], x, y);
          x = x - context.measureText(tagline[i]).width - 2;
        }
        context.beginPath();
        context.moveTo(margins.left, topMargin + logoHeight + 10);
        context.lineTo(width - margins.right, topMargin + logoHeight + 10);
        context.closePath();
        context.strokeStyle = common_module_scss_1.default.chartAxisTickColor;
        context.lineWidth = 2;
        context.stroke();
        resolve();
      };
      logoImage.onerror = error => {
        console.error(error);
        reject();
      };
      logoImage.src = logo;
    });
  }
};